export default "__VITE_ASSET__Ci5_ONym__"